import React from 'react';
import { getLinkIcon, getLinkSubtype } from '../../../../tools/linkSubtypeConfig';

const LinkBar = ({ infoData }) => {
    const linkDatums = infoData.filter(d => 
        d.datumType === 'link' && 
        d.datumText
    );

    if (linkDatums.length === 0) return null;

    const bySubtype = {};
    for (const datum of linkDatums) {
        const subtype = datum.linkSubtype || 'website';
        if (!bySubtype[subtype] || datum.stampDetails.length > bySubtype[subtype].stampDetails.length) {
            bySubtype[subtype] = datum;
        }
    }

    return (
        <div className="iv-link-bar iv-stats FlexRow">
            {Object.entries(bySubtype).map(([subtype, datum]) => {
                const config = getLinkSubtype(subtype);
                return (
                  <a
                    key={subtype}
                    href={datum.datumText}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="iv-link-icon"
                    title={`${config.label}: ${datum.datumText}`}
                    style={{ color: config.color }}
                >
                    {getLinkIcon(subtype, '1.4rem')}
                </a>
                );
            })}
        </div>
    );
};

export default LinkBar;